export const LOCAL_STORAGE_PENDING_RELOAD_KEY =
  '@appfolio/backstage-pending-reload';
